import { ActionType, IAction, SurveyMode } from '../types'

export default function loaderAction(actionProps: Partial<IAction> = {}): IAction {
  return { ...actionProps, action: ActionType.LOADER, mode: actionProps.mode || SurveyMode.RESPONDENT }
}
